import React from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import WizardPage from './pages/WizardPage';
import CompletePage from './pages/CompletePage';

/**
 * Guards a route so only authenticated clients can access it.
 * Preserves the current path so we can redirect back after login.
 */
function ProtectedRoute({ children }) {
  const { client, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-dark" role="status">
          <span className="visually-hidden">Loading…</span>
        </div>
      </div>
    );
  }

  if (!client) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public login — also handles ?token= magic links */}
          <Route path="/login" element={<LoginPage />} />

          {/* Wizard (protected) */}
          <Route
            path="/wizard"
            element={
              <ProtectedRoute>
                <WizardPage />
              </ProtectedRoute>
            }
          />

          {/* Completion confirmation */}
          <Route
            path="/complete"
            element={
              <ProtectedRoute>
                <CompletePage />
              </ProtectedRoute>
            }
          />

          {/* Default: redirect to login; token in URL will auto-login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
